<template>
  <div id="custom-online">
    <Breadcrumb></Breadcrumb>
    <div style="text-align: right;margin: 8px 0 12px 0;">
      <el-button @click="handleQuit()" size="small">取消</el-button>
      <el-button
        v-if="formType == '1'"
        type="primary"
        @click="handleSubmitForm('1')"
        size="small"
        >保存</el-button
      >
      <el-button
        type="primary"
        v-if="formType == '1'"
        @click="handleSubmitForm('2')"
        size="small"
        >保存并认领到Amazon</el-button
      >
      <el-button
        v-if="formType == '2'"
        type="primary"
        @click="handleSubmitForm('3')"
        size="small"
        >保存</el-button
      >
      <el-button
        type="primary"
        v-if="form.pubStatus != '02' && formType == '2'"
        @click="handleSubmitForm('4')"
        size="small"
        >保存并移入待发布</el-button
      >
      <el-button
        type="primary"
        v-if="formType == '3'"
        @click="handleSubmitForm('4')"
        size="small"
        >保存</el-button
      >
    </div>
    <input
      v-show="false"
      type="file"
      id="fileUpload"
      name="file"
      @change="handleSaveFile"
    />
    <el-form
      :model="form"
      ref="form"
      label-width="150px"
      :rules="rules"
      class="product-form"
    >
      <div class="t_plane self_el_item_form">
        <div class="pl_til">基本信息</div>
        <div class="pl_content">
          <el-form-item
            label="来源URL："
            style="margin-top: 20px"
            prop="dataUrl"
          >
            <el-input v-model="form.dataUrl" size="small"></el-input>
          </el-form-item>
          <el-form-item
            label="产品名称："
            style="margin-top: 20px"
            prop="proName"
            :rules="[
              { required: true, message: '请输入内容', trigger: 'blur' },
            ]"
          >
            <el-input v-model="form.proName" size="small"></el-input>
          </el-form-item>
          <el-form-item
            v-if="false"
            label="店铺名称："
            style="margin-top: 20px"
            prop="shopId"
          >
            <el-select
              clearable
              v-model="form.shopId"
              placeholder="请选择"
              size="small"
              style="width:100%"
            >
              <el-option
                v-for="(record, index) in shopList"
                :key="index"
                :label="record.shopName"
                :value="record.shopId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="false" prop="platId" label="产品分类：">
            <el-cascader
              style="width: 100%"
              size="mini"
              expand-trigger="hover"
              :options="platTypeList"
              :props="optionProps"
              v-model="form.platId"
              @change="handleChangePlatId"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item
            v-if="false"
            prop="external_product_id_type"
            :rules="[
              { required: true, message: '请输入内容', trigger: 'blur' },
            ]"
            label="商品编码类型："
          >
            <el-select
              style="width: 100%"
              clearable
              size="mini"
              v-model="form.external_product_id_type"
              placeholder="请选择"
              @change="handleChangeProductType"
            >
              <el-option
                v-for="(record, index) in externalProductIdTypeOptions"
                :label="record.engValName"
                :value="record.engValName"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            v-if="false"
            prop="external_product_id"
            :rules="[
              { required: true, message: '请输入内容', trigger: 'blur' },
            ]"
            label="商品编码："
          >
            <el-select
              style="width: 100%"
              clearable
              size="mini"
              v-model="form.external_product_id"
              placeholder="请选择"
            >
              <el-option
                v-for="(record, index) in productIds"
                :key="index"
                :label="record.name"
                :value="record.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="false"
            prop="productPicAddr"
            label="同步产品图片地址："
          >
            <el-select
              clearable
              style="width: 100%"
              size="mini"
              v-model="form.productPicAddr"
              placeholder="请选择产品图片地址"
            >
              <el-option
                v-for="(record, index) in pictureAddresses"
                :key="index"
                :label="record"
                :value="record"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
      <div id="template" v-if="false" class="title">属性信息</div>
      <el-form
        v-for="(record, index) of groups"
        :ref="`form${index}`"
        :key="index"
        :model="forms[index]"
        label-width="200px"
        v-if="
          templateViews.includes(groups[index][0].importType) &&
            groups[index][0].groupBy !== 'proPicGroup'
        "
      >
        <div class="basic">
          <div
            @click="groups[index][0].visible = !groups[index][0].visible"
            class="form-title"
          >
            <i v-if="!groups[index][0].visible" class="el-icon-plus"></i>
            <i v-if="groups[index][0].visible" class="el-icon-minus"></i>
            {{ groups[index][0].groupBy }}
          </div>
          <div v-show="groups[index][0].visible" class="form-content">
            <el-form-item
              v-for="(item, number) of record"
              :label="item.labelName + '：'"
              :key="number"
              :prop="item.attrId"
              :rules="
                item.importType === 'Required' &&
                !item.disabled &&
                (item.groupBy === 'Required' || item.groupBy === '必填项') &&
                item.fieldName !== 'item_sku'
                  ? [{ required: true, message: '请输入内容', trigger: 'blur' }]
                  : []
              "
              v-if="
                !(
                  item.fieldName == 'quantity' ||
                  item.fieldName == 'external_product_id_type' ||
                  item.fieldName == 'external_product_id' ||
                  item.fieldName == 'bullet_point1' ||
                  item.fieldName == 'bullet_point2' ||
                  item.fieldName == 'bullet_point3' ||
                  item.fieldName == 'bullet_point4' ||
                  item.fieldName == 'bullet_point5' ||
                  item.fieldName == 'product_description'
                )
              "
            >
              <div class="form-label" slot="label">
                <div
                  :title="item.labelName"
                  style="width: 176px;"
                  class="text-ellipsis"
                >
                  {{ item.labelName }}：
                </div>
                <div
                  :title="item.fieldName"
                  style="width: 176px;"
                  class="text-ellipsis field-name"
                >
                  （{{ item.fieldName }}）
                </div>
              </div>
              <div v-if="false" style="display: inline-block" slot="label">
                <!-- <p>{{ item.labelName }}：</p> -->
                <!-- <p style="font-size:12px;">{{ item.fieldName }}</p> -->
              </div>
              <div class="form-control">
                <el-input
                  v-if="item.disabled"
                  size="mini"
                  :disabled="true"
                  placeholder="根据汇出的产品自动生成"
                ></el-input>
                <div
                  v-else-if="
                    item.dataType == '01' && item.fieldName == 'item_sku'
                  "
                >
                  <el-input
                    v-model="itemSkuBefore"
                    style="width:100px"
                    size="mini"
                    placeholder=""
                  ></el-input>
                  <el-input
                    style="width:50px;margin: 0 8px;"
                    size="mini"
                    placeholder="{id}"
                  ></el-input>
                  <el-input
                    v-model="itemSkuAfter"
                    style="width:100px"
                    size="mini"
                    placeholder=""
                  ></el-input>
                </div>
                <el-input
                  v-else-if="item.dataType == '01' && item.varUseFlag === null"
                  size="mini"
                  v-model="forms[index][item.attrId]"
                ></el-input>
                <!--文本域-->
                <div
                  v-else-if="item.dataType == '04' || item.varUseFlag === '1'"
                >
                  <div class="variable-insert">
                    <div class="insert-link">
                      插入变量
                      <div class="variable-select-menu">
                        <ul>
                          <li
                            class="variable-select-box-text"
                            :key="number"
                            v-for="(record, number) in varList"
                            @click="
                              handleInsertVariable(
                                forms,
                                index,
                                item.attrId,
                                record.var
                              )
                            "
                          >
                            {{ record.name }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <i
                      @mouseenter="handleShowVarHelp"
                      @mouseout="showVarHelp = false"
                      class="el-icon-question"
                    ></i>
                  </div>
                  <el-input
                    type="textarea"
                    placeholder="请输入内容"
                    v-model="forms[index][item.attrId]"
                    show-word-limit
                    :rows="3"
                    size="mini"
                  >
                  </el-input>
                </div>
                <!--单选-->
                <el-select
                  clearable
                  v-model="forms[index][item.attrId]"
                  placeholder="请选择"
                  size="mini"
                  v-else-if="item.dataType == '02'"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item_2, index_2) in item.sPlatProVals"
                    :key="index_2"
                    :label="item_2.valName"
                    :value="item_2.engValName"
                    >{{ item_2.valName }}
                  </el-option>
                </el-select>
                <!--多选-->
                <el-select
                  clearable
                  v-model="forms[index][item.attrId]"
                  multiple
                  placeholder="请选择"
                  size="mini"
                  v-else-if="item.dataType == '03'"
                  style="width: 100%"
                >
                  <el-option
                    v-for="(item_2, index_2) in item.sPlatProVals"
                    :key="index_2"
                    :label="item_2.valName"
                    :value="item_2.engValName"
                  >
                  </el-option>
                </el-select>
                <!--枚举多选-->
                <div v-else-if="item.dataType == '06'" class="attrVal">
                  <el-checkbox
                    :indeterminate="isIndeterminate"
                    v-model="forms[index][item.attrId]"
                    @change="checkde"
                    >全选</el-checkbox
                  >
                  <div style="margin: 15px 0"></div>
                  <el-checkbox-group
                    v-model="forms[index][item.attrId]"
                    @change="checkedManyVal"
                  >
                    <el-checkbox
                      v-for="(item_2, index_2) in item.sPlatProVals"
                      :key="index_2"
                      :label="item_2.engValName"
                      >{{ item_2.valName }}</el-checkbox
                    >
                  </el-checkbox-group>
                </div>

                <!--枚举单选-->
                <div v-else-if="item.dataType == '05'" class="attrVal">
                  <el-radio
                    v-model="forms[index][item.attrId]"
                    :key="index_2"
                    :label="item_2.engValName"
                    v-for="(item_2, index_2) in item.sPlatProVals"
                    >{{ item_2.valName }}</el-radio
                  >
                </div>
                <!--时间-->
                <el-date-picker
                  v-model="forms[index][item.attrId]"
                  type="datetime"
                  placeholder="选择日期时间"
                  v-else-if="item.dataType == '07'"
                >
                </el-date-picker>
              </div>

              <div class="form-remark">
                （{{ importTypeMap[item.importType] }}）
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="item.acceptedValues"
                  placement="top"
                >
                  <i class="el-icon-question"></i>
                </el-tooltip>
              </div>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <el-form v-if="formType !== '1'" label-width="200px">
        <div class="basic">
          <div class="form-title">
            描述信息
          </div>
          <div class="form-content">
            <el-form-item>
              <div class="form-label" slot="label">
                <div
                  title="product_description:"
                  style="width: 176px;"
                  class="text-ellipsis"
                >
                  product_description：
                </div>
                <div
                  title="长描述"
                  style="width: 176px;"
                  class="text-ellipsis field-name"
                >
                  （长描述）
                </div>
              </div>
              <div class="form-control">
                <el-input
                  type="textarea"
                  placeholder="请输入内容"
                  show-word-limit
                  :rows="3"
                  size="mini"
                  v-model="form.proDesc"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="form-label" slot="label">
                <div
                  title="bullet_point1:"
                  style="width: 176px;"
                  class="text-ellipsis"
                >
                  bullet_point1:
                </div>
                <div
                  title="Key Product Features"
                  style="width: 176px;"
                  class="text-ellipsis field-name"
                >
                  （Key Product Features）
                </div>
              </div>
              <div class="form-control">
                <el-input size="mini" v-model="form.bulletPoint1"></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="form-label" slot="label">
                <div
                  title="bullet_point2:"
                  style="width: 176px;"
                  class="text-ellipsis"
                >
                  bullet_point2:
                </div>
                <div
                  title="Key Product Features"
                  style="width: 176px;"
                  class="text-ellipsis field-name"
                >
                  （Key Product Features）
                </div>
              </div>
              <div class="form-control">
                <el-input size="mini" v-model="form.bulletPoint2"></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="form-label" slot="label">
                <div
                  title="bullet_point3:"
                  style="width: 176px;"
                  class="text-ellipsis"
                >
                  bullet_point3:
                </div>
                <div
                  title="Key Product Features"
                  style="width: 176px;"
                  class="text-ellipsis field-name"
                >
                  （Key Product Features）
                </div>
              </div>
              <div class="form-control">
                <el-input size="mini" v-model="form.bulletPoint3"></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="form-label" slot="label">
                <div
                  title="bullet_point4:"
                  style="width: 176px;"
                  class="text-ellipsis"
                >
                  bullet_point4:
                </div>
                <div
                  title="Key Product Features"
                  style="width: 176px;"
                  class="text-ellipsis field-name"
                >
                  （Key Product Features）
                </div>
              </div>
              <div class="form-control">
                <el-input size="mini" v-model="form.bulletPoint4"></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <div class="form-label" slot="label">
                <div
                  title="bullet_point5:"
                  style="width: 176px;"
                  class="text-ellipsis"
                >
                  bullet_point5:
                </div>
                <div
                  title="Key Product Features"
                  style="width: 176px;"
                  class="text-ellipsis field-name"
                >
                  （Key Product Features）
                </div>
              </div>
              <div class="form-control">
                <el-input size="mini" v-model="form.bulletPoint5"></el-input>
              </div>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <!--SKU信息-->
      <div class="t_plane self_el_item_form">
        <div class="pl_til">SKU信息</div>
        <div class="pl_content">
          <div v-if="formType == '2' || formType == '3'" class="color-list">
            <div style="display:inline-block;font-size:14px;margin: 0 8px 0 0;">
              颜色：
            </div>
            <el-tag
              :key="tag"
              v-for="tag in colorTags"
              closable
              :disable-transitions="false"
              @close="handleColorClose(tag)"
            >
              {{ tag }}
            </el-tag>
            <el-input
              class="input-new-tag"
              v-if="inputColorVisible"
              v-model="inputColorValue"
              ref="saveTagColorInput"
              size="small"
              @keyup.enter.native="handleColorInputConfirm"
              @blur="handleColorInputConfirm"
            >
            </el-input>
            <el-button
              v-else
              class="button-new-tag"
              size="small"
              @click="showColorInput"
              >+ 新增颜色</el-button
            >
          </div>
          <div v-if="formType === '2' || formType == '3'" class="size-list">
            <div style="display:inline-block;font-size:14px;margin: 0 8px 0 0;">
              尺寸：
            </div>
            <el-tag
              :key="tag"
              v-for="tag in sizeTags"
              closable
              :disable-transitions="false"
              @close="handleSizeClose(tag)"
            >
              {{ tag }}
            </el-tag>
            <el-input
              class="input-new-tag"
              v-if="inputSizeVisible"
              v-model="inputSizeValue"
              ref="saveTagSizeInput"
              size="small"
              @keyup.enter.native="handleSizeInputConfirm"
              @blur="handleSizeInputConfirm"
            >
            </el-input>
            <el-button
              v-else
              class="button-new-tag"
              size="small"
              @click="showSizeInput"
              >+ 新增尺寸</el-button
            >
          </div>
          <div class="sku-list">
            <el-table
              id="outTable"
              ref="table"
              :data="skuList"
              tooltip-effect="dark"
              style="width: 100%"
              :header-cell-style="{ 'text-align': 'center' }"
            >
              <el-table-column prop="name" label="变种信息" align="center">
                <template slot-scope="scope">
                  <div v-html="scope.row.properVal"></div>
                </template>
              </el-table-column>
              <el-table-column label="价格" align="center">
                <template slot="header">
                  价格(<span
                    @click="handleShowPriceDialog('price')"
                    class="primary-color pointer"
                    >一键设置</span
                  >)
                </template>
                <template slot-scope="scope">
                  <el-input
                    size="small"
                    onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g,'');"
                    v-model="scope.row.price"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="库存" align="center">
                <template slot="header">
                  库存(<span
                    @click="handleShowPriceDialog('quantity')"
                    class="primary-color pointer"
                    >一键设置</span
                  >)
                </template>
                <template slot-scope="scope">
                  <el-input
                    size="small"
                    onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g,'');"
                    v-model="scope.row.quantity"
                  ></el-input>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <!--变种图片-->
      <div class="t_plane self_el_item_form">
        <div class="pl_til">变种图片</div>
        <div class="pl_content">
          <div v-for="(value, key) in picList" :key="key" class="color-content">
            <div class="pl-title">
              <span style="margin: 0 16px 0 0;">变种信息：{{ key }}</span>
              <el-button
                v-if="$route.query.type"
                size="mini"
                type="text"
                @click="handleShowPicture(key)"
                >引用采集图片</el-button
              >
            </div>
            <ul
              class="extra-image-ul letter w70 detail-image-ul amazon sort-img active"
            >
              <draggable
                :list="value"
                style="overflow:hidden;"
                filter=".forbid"
                @start="drag = true"
                @end="drag = false"
                :move="onMove"
              >
                <li
                  v-for="(record, index) in value"
                  :key="index"
                  class="sort-img-item"
                  :class="index === 0 ? 'forbid' : ''"
                >
                  <div v-if="record.isMain == '1'" class="item-badge">主图</div>
                  <img :src="record.picUrl" />
                  <span class="first-pro-icon icon-corner-mark"></span>
                  <div class="wish-product-img-ope">
                    <a
                      style="color: #ffffff;"
                      v-if="record.isMain == '0'"
                      @click.prevent="handleSetMainImage(value, index)"
                      class="set-main"
                      >设为主图</a
                    >
                    <a
                      style="color: #ffffff;"
                      @click.prevent="hanldeDeleteImage(value, index)"
                      class="set-delete"
                      >移除</a
                    >
                  </div>
                </li>
                <li
                  @click="handleUploadImage(key)"
                  v-if="value.length < 9"
                  class="sort-img-item add-image-button forbid"
                >
                  <p><i class="el-icon-plus"></i></p>
                </li>
              </draggable>
            </ul>
          </div>
        </div>
      </div>

      <!--描述信息-->
      <div v-if="formType === '1'" class="t_plane self_el_item_form">
        <div style="margin: 0 0 16px 0;" class="pl_til">描述信息</div>
        <el-form-item class="wd100" label="简易描述：">
          <el-input
            type="textarea"
            :rows="5"
            v-model="form.proDesc"
            placeholder="请输入内容"
            size="mini"
          ></el-input>
        </el-form-item>
        <el-form-item class="wd100" label="详细描述：">
          <CKEditor4
            v-model="form.content"
            :config="editorConfig"
            @getCkEditorInstance="getEditorRemarks"
            @input="handleChangeEditor"
          ></CKEditor4>
        </el-form-item>
      </div>
    </el-form>

    <el-dialog
      :close-on-click-modal="false"
      title="一键设置"
      :visible.sync="showPriceDialog"
      width="560px"
      @close="handleClosePriceDialog"
    >
      <el-row style="margin-top: 15px;margin-left: 15px">
        数值：<el-input
          v-model.trim="priceModify"
          onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d*(\.?\d{0,2})/g,'');"
          placeholder="请输入数值"
          size="mini"
          style="width: 450px"
        ></el-input>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClosePriceDialog" size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="handleUpdatePrice" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="引用采集图片"
      :visible.sync="showPictureDialog"
      width="800px"
      @close="handleClosePictureDialog"
    >
      <div
        style="overflow:hidden;margin: 16px 0 0 0;height:60vh;overflow-y: auto;"
      >
        <div
          style="float:left;margin:0 8px 16px 0;"
          v-for="(record, index) in imageList"
          :key="index"
          class=""
        >
          <div>
            <el-checkbox v-model="record.checked">选择图片</el-checkbox><br />
            <img
              @click="handleCheckPicture(record)"
              :src="record.picUrl"
              style="width:115px;height:115px;cursor:pointer;"
            />
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClosePictureDialog" size="small"
          >取 消</el-button
        >
        <el-button type="primary" @click="handlePickImage" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <VarHelp ref="varHelp" v-show="showVarHelp"></VarHelp>
  </div>
</template>

<script type="text/ecmascript-6">
import Breadcrumb from '@/components/common/Breadcrumb'
import ElRow from "element-ui/packages/row/src/row";
import CKEditor4 from '@/components/common/CKEditor'
import TreeSelect from '@/components/common/treeSelect';
import { getProductTypeTree } from "@/api/product/type";
import draggable from "vuedraggable"
import { getProList } from "@/api/plat/platType";
import { getProductTypeList } from "@/api/plat/platType";
import { addTemplate, getTemplateInfo, addRemit, getVarListColl } from "@/api/template/template";
import VarHelp from './components/varHelp.vue'
import { getCollInfo,editColl,editGetColl,getImage } from "@/api/product/coll"
import { addProduct, getProductInfo } from "@/api/product/amazon"
import { getShopList } from "@/api/system/shopManage"
import {mapGetters} from 'vuex'
import { getOSSToken } from "@/api/setting";
import { getConfigKey } from "@/api/system/config";
import { uploadFile } from "@/api/upload/upload"
import { getDomainList, } from "@/api/system/domain"

export default {
    name: "product",
    components:{
        ElRow,
        Breadcrumb,
        CKEditor4,
        TreeSelect,
        draggable,
        VarHelp
    },
    computed: {
      ...mapGetters(["dictData", "dictMap"]),
    },
    data(){
      return{
        formType: "1",
        priceModify: '',
        form:{
          typeId: '',
          basicId: '',
          proCode: '',
          proName: '',
          engProName: '',
          prodTech: '',
          pdMaterial: '',
          prodDays: '',
          manufacturer: '',
          attribute: '',
          desiHint: '',
          reminder: '',
          remarks: '',
          dzStatus: '',
          productType: '01',
          saleType: false,
          skuList: [],
          saleForm: '01',
          platId: '',
          shopId: '',
          external_product_id_type: '',
          external_product_id: '',
          bulletPoint1: '',
          bulletPoint2: '',
          bulletPoint3: '',
          bulletPoint4: '',
          bulletPoint5: '',
          proDesc: ''
        },
        productTypeList: [],
        treeSelectProps: {
          value:'typeId',             // ID字段名
          label: 'typeName',         // 显示名称
          children: 'childrenTree'    // 子级字段名
        },
        colorTags: [],
        externalProductIdTypeOptions: [],
        inputColorVisible: false,
        inputColorValue: '',
        sizeTags: [],
        inputSizeVisible: false,
        inputSizeValue: '',
        skuList: [],
        picList: {},
        currentColor: '',
        aliyunOssToken: {},
        rules: {
            productType: [
                {required: true, message: '请输入产品类型', trigger: 'change'},
            ],
            basicId: [
                {required: true, message: '请输入定制ID', trigger: 'blur'},
            ],
            proCode: [
                {required: true, message: '请输入产品编号', trigger: 'blur'},
            ],
            proName: [
                {required: true, message: '请输入中文名称', trigger: 'blur'},
            ],
            typeId: [
                {required: true, message: '请选择产品分类', trigger: 'blur'},
            ],
             saleForm: [
                {required: true, message: '请选择售卖方式', trigger: 'blur'},
            ],
            platId: [
                {required: true, message: '请选择产品分类', trigger: 'blur'},
            ],
            shopId: [
                {required: true, message: '请输入店铺名称', trigger: 'blur'},
            ],
            productPicAddr: [
                {required: true, message: '请选择同步产品图片地址', trigger: 'blur'},
            ],
            prodDays: [
                {required: true, message: '请输入生产时长', trigger: 'blur'},
            ],
            manufacturer: [
                {required: true, message: '请输入生产厂商', trigger: 'blur'},
            ],
            price: [
                { required: true, message: '请输入价格', trigger: 'blur' },
            ],
            commSku: [
                { required: true, message: '请输入SKU', trigger: 'blur' },
            ],
            packWeight: [
                { required: true, message: '请输入包装重量', trigger: 'blur' },
            ],
            packLong: [
                { required: true, message: '请输入包装尺寸长', trigger: 'blur' },
            ],
            packWide: [
                { required: true, message: '请输入包装尺寸宽', trigger: 'blur' },
            ],
            packHigh: [
                { required: true, message: '请输入包装尺寸高', trigger: 'blur' },
            ],
        },
        showPriceDialog: false,
        showPictureDialog: false,
        //描述文本框
        editorRemarks:null,
        editorConfig:{
            // extraPlugins:'myplug',
            height:'300px',
            toolbar : [
                [ 'Source','Maximize'],
                [ 'Bold', 'Italic', 'Underline', 'Strike'],
                [ 'TextColor', 'BGColor' ],
                [  'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock','-','NumberedList', 'BulletedList', '-', 'Outdent', 'Indent',  '-','Subscript', 'Superscript'],
                [ 'HorizontalRule','RemoveFormat'],
                ['NewPage', 'Preview', '-', 'Undo', 'Redo' ],
                '/',
                [ 'Styles', 'Format', 'Font', 'FontSize' ],
                [ 'Paste', 'PasteText', 'PasteFromWord','Table'],
                [ 'Link', 'Unlink','-' ,'Image']
            ],
            language: 'zh-cn',
            wordcount:{
                showCharCount: true,
            }
        },
        priceType: '',
        platTypeList: [],
        optionProps: {
        value: "platId",
        label: "platName",
        children: "childrenTree",
        },
        formItems: [],
        groups: [],
        forms: [],
        templateViews: ["Required"],
        checkedAll: false,
        importTypeMap: {
          Required: "重要",
          Optional: "可选",
          Preferred: "首选",
        },
        attrMap: {},
        showVarHelp: false,
        varList: [],
        imageGroup: [
        ],
        shopList: [],
        imageList: [],
        currentPicture: '',
        collId: '',
        itemSkuBefore: '',
        itemSkuAfter: '',
        pictureAddresses: [],
         productIds: [{
        name: '按设置生成',
        value: '1'
      },
      {
        name: '不汇出',
        value: '0'
      }],
       showMeta: false
      }
    },
    async created() {
      let collId = this.$route.query.collId
      let pId = this.$route.query.pId
      let formType = this.$route.query.type
      if(!formType){
        formType = "2"
      }
      if(!pId && !collId){
        formType = '3'
      }

      this.formType = formType

      await this.getPlatTypeList()
      await this.getVarListColl()
      this.getConfigKey()
      this.getShopData()

      let data  = null
      if(collId){
        let result = await getCollInfo(collId)
        data = result.data
      }
      if(pId){
        let result = await getProductInfo(pId)
        data = result.data
        collId = data.collId
        // if(data.platId){
        //   this.getTemplate({platId: data.platId, pId: data.pId})
        // }
      }
      if(data){
        let form = data;
        form.collId = collId
        this.form = form
        this.collId = collId
        let attribute = JSON.parse(data.attribute)
        this.colorTags = attribute['颜色']
        this.sizeTags = attribute['尺码']
        //开始渲染SKU信息
        let picList =  {}
        for(let record of data.skuList){
            let row = this._.pick(record,'price', 'quantity','properVal')
            let color = row.properVal.split(':')[0]
            if(!picList[color]){
              picList[color] = record.picList
            }
            this.skuList.push({
                color: color,
                properVal: row.properVal,
                price:  row.price,
                quantity: row.quantity,
            })
        }
        this.picList = picList
      }
    },
    methods:{
      handleCheckPicture(record){
        record.checked = !record.checked
      },
      async handleShowPicture(color) {
        let result  = await getImage(this.collId)
        result.data.map(record=>{
          record.checked = false
        })
        this.imageList = result.data
        this.currentPicture = color
        this.showPictureDialog = true
      },
      handlePickImage(){
        for(let record of this.imageList){
          if(record.checked){
            this.picList[this.currentPicture].push({
              picUrl: record.picUrl,
              isMain: this.picList[this.currentPicture].length === 0 ? true : false
            })
          }
        }
        this.showPictureDialog = false
      },
      getShopData() {
        getShopList({ platNo: "04" }).then((res) => {
          this.shopList = res.rows
        })
      },
      handleChangePlatId(value) {
        let vals = this.getCascaderObj(value, this.platTypeList);
        if (vals.length > 0) {
          let node = vals[vals.length - 1];
          // this.feedProductType = node.feedProductType;
          // this.itemType = node.itemType;
          this.getTemplate({platId : node.platId, pId: this.form.pId});
        }
      },
      getCascaderObj(val, opt) {
        return val.map(function (value, index, array) {
          for (var itm of opt) {
            if (itm.platId == value) {
              opt = itm.childrenTree;
              return itm;
            }
          }
          return null;
        });
      },
      async getVarListColl(){
        let result = await getVarListColl()
        this.varList = result.rows
      },
      handleInsertVariable(forms,index,attrId, value){
       forms[index][attrId] = (forms[index][attrId] ? forms[index][attrId] : '') + value
      },
      getTemplate({platId , pId}) {
      this.startLoading()
       getProList({ platId, pId }).then(
          (data) => {
            let forms = [];
            let groups = [];
            for (let i = 0; i < data.rows.length; i++) {
               //设置零售价和库存

            if(data.rows[i].fieldName === 'item_sku'){
              if(data.rows[i].engValName){
              let fieldValue =  data.rows[i].engValName.split('{id}')
              if(fieldValue && fieldValue.length > 1){
                this.itemSkuBefore = fieldValue[0]
                this.itemSkuAfter = fieldValue[1]
              }
              } else{
                this.itemSkuBefore = ''
                this.itemSkuAfter = ''
              }
            }
            if(data.rows[i].fieldName === 'external_product_id_type'){
              this.externalProductIdTypeOptions = data.rows[i].sPlatProVals
              this.form.external_product_id_type = data.rows[i].engValName
            }
            if(data.rows[i].fieldName === 'external_product_id'){
              this.form.external_product_id = data.rows[i].engValName
            }
             if(data.rows[i].fieldName === 'bullet_point1'){
              this.showMeta = true
              this.form.bullet_point1 = data.rows[i].engValName
            }
              if(data.rows[i].fieldName === 'bullet_point2'){
              this.form.bullet_point2 = data.rows[i].engValName
            }
              if(data.rows[i].fieldName === 'bullet_point3'){
              this.form.bullet_point3 = data.rows[i].engValName
            }
              if(data.rows[i].fieldName === 'bullet_point4'){
              this.form.bullet_point4 = data.rows[i].engValName
            }
              if(data.rows[i].fieldName === 'bullet_point5'){
              this.form.bullet_point5 = data.rows[i].engValName
            }
              if(data.rows[i].fieldName === 'product_description'){
              this.form.product_description = data.rows[i].engValName
            }


            if(data.rows[i].fieldName === 'relationship_type' && !data.rows[i].engValName){
              data.rows[i].engValName = 'Variation'
            }
             if(data.rows[i].fieldName === 'variation_theme' && !data.rows[i].engValName){
              data.rows[i].engValName = 'color-size'
            }

            data.rows[i].visible = true;
            this.attrMap[data.rows[i].attrId] = data.rows[i].fieldName
            if (groups.length == 0) {
              groups.push([data.rows[i]]);
              forms.push({ [data.rows[i].attrId]: data.rows[i].engValName });
              continue;
            }
            let isFind = false;
            for (let j = 0; j < groups.length; j++) {
              for (let k = 0; k < groups[j].length; k++) {
                if (groups[j][k].groupBy === data.rows[i].groupBy) {
                  isFind = true;
                  groups[j].push(data.rows[i]);
                  forms[j][data.rows[i].attrId] = data.rows[i].engValName;
                  break;
                }
              }
            }
            if (!isFind) {
              groups.push([data.rows[i]]);
              forms.push({ [data.rows[i].attrId]: data.rows[i].engValName });
            }
            }
            this.formItems = data.rows;
            this.forms = forms;
            this.groups = groups;
            this.endLoading()
          }
        );
      },
      async getPlatTypeList() {
        let result = await getProductTypeList({platNo: '04'});
        this.platTypeList = result.data;
      },
      handleCheckAll() {
        if (this.checkedAll) {
          this.templateViews = ["Required", "Optional", "Preferred"];
        } else {
          this.templateViews = ["Required"];
        }
      },
      onMove(e){
        if(!e.relatedContext.element){
          return false
        }
        if(e.relatedContext.element.isMain){
          return false
        }
        return true
      },
      handleUpdatePrice(){
        for(let record of this.skuList){
          if(this.priceType === 'price'){
            record.price = this.priceModify
          }else if(this.priceType === 'quantity'){
            record.quantity = this.priceModify
          }
        }
        this.showPriceDialog = false
      },
      handleClosePriceDialog(){
        this.showPriceDialog = false
      },
      handleClosePictureDialog(){
        this.showPictureDialog = false
      },
      handleShowPriceDialog(priceType){
        this.priceModify = ''
        this.showPriceDialog = true
        this.priceType = priceType
      },
      async handleSubmitForm(submitWay){
        this.$refs['form'].validate(async (valid)=>{
            if(!valid){
              return
            }
            if(this.$refs["form0"]){
              this.$refs["form0"][0].validate(async (auth)=>{
                if(!auth){
                  return
                }
                this.submit(submitWay)
              })
            }else{
               this.submit(submitWay)
            }

        })
      },
      async submit(submitWay){
        let form = JSON.parse(JSON.stringify(this.form))
        if(this.editorRemarks){
          form.content = this.editorRemarks.getData()
        }
        // form.saleType = form.saleType ? "1" : "0"
        let skuList = []
        let skuListClone = JSON.parse(JSON.stringify(this.skuList))
        for(let record of skuListClone){
          for(let key in this.picList){
            if(!record.picList && key === record.color){
              record.picList = this.picList[key]
              for(let item of record.picList){
                item.isMain = item.isMain == "1" ? "1" : "0"
              }
              break
            }
          }
          skuList.push(record)
          if(record.quantity == ''){
            this.msgError('库存信息不能为空')
            return
          }
          if(record.picList.length == 0){
             this.msgError('变种图片不能为空')
            return
          }
        }
        if(skuList.length == 0){
          this.msgError('SKU信息不能为空')
          return
        }
        form.skuList = skuList
        form.attrList = undefined
        // if(typeof(form.platId) === 'object'){
        //   form.platId = form.platId[form.platId.length - 1];
        // }
        // if(this.forms){
        //    for (let i=0; i< this.groups.length;i++) {
        //     for (let item of this.groups[i]) {
        //       if(item.fieldName === 'external_product_id_type'){
        //           this.forms[i][item.attrId] = this.form.external_product_id_type
        //           continue
        //         }
        //       if(item.fieldName === 'external_product_id'){
        //         this.forms[i][item.attrId] = this.form.external_product_id
        //         continue
        //       }
        //       if(this.showMeta){
        //         if(item.fieldName === 'bullet_point1'){
        //           this.forms[i][item.attrId] = this.form.bullet_point1
        //           continue
        //         }
        //           if(item.fieldName === 'bullet_point2'){
        //           this.forms[i][item.attrId] = this.form.bullet_point2
        //           continue
        //         }
        //           if(item.fieldName === 'bullet_point3'){
        //           this.forms[i][item.attrId] = this.form.bullet_point3
        //           continue
        //         }
        //           if(item.fieldName === 'bullet_point4'){
        //           this.forms[i][item.attrId] = this.form.bullet_point4
        //           continue
        //         }
        //         if(item.fieldName === 'bullet_point5'){
        //           this.forms[i][item.attrId] = this.form.bullet_point5
        //           continue
        //         }
        //         if(item.fieldName === 'product_description'){
        //           this.forms[i][item.attrId] = this.form.product_description
        //           continue
        //         }
        //       }

        //       if(item.fieldName === 'item_sku'){
        //         let value = this.itemSkuBefore + '{id}' + this.itemSkuAfter
        //         this.forms[i][item.attrId] = value
        //         continue
        //       }
        //     }
        //   }
        //   for (let record of this.forms) {
        //     for (let key in record) {
        //       form.attrList.push({
        //         attrId: key,
        //         fieldName:  this.attrMap[key],
        //         engValName: record[key],
        //       });
        //     }
        //  }
        // }
        form.attribute = JSON.stringify({
          '尺码': this.sizeTags,
          '颜色': this.colorTags
        })
        try {
          if(submitWay == "1"){
            await editColl(form)
            this.$router.push({ path: "/product/comFun/dataCollection" })
          }else if(submitWay == "2"){
            await editGetColl(form)
            this.$router.push({ path: "/product/amazon/coll" })
          }else if(submitWay == "3"){
            if(form.pubStatus == '01'){
              let action = this.$route.query.action
              if(action && action == 'new'){
                form.pId = undefined
              }
              await addProduct(form)
              this.$router.push({ path: "/product/amazon/coll" })
            } else {
              let action = this.$route.query.action
              if(action && action == 'new'){
                form.pId = undefined
                form.pubStatus = '02'
              }
              await addProduct(form)
              this.$router.push({ path: "/product/amazon/readyRelease" })
            }
          }else if(submitWay == "4"){
            form.pubStatus = '02'
            await addProduct(form)
            this.$router.push({ path: "/product/amazon/readyRelease" })
          }
          this.msgSuccess("保存成功");
        } catch (error) {
        }
      },
      handleQuit(){
        this.$router.go(-1)
      },
      async getProductTypeTree() {
        let result = await getProductTypeTree();
        this.productTypeList = result.data;
      },
      getTreeNodeId(value){
        this.form.typeId = value
      },
      handleAddPrice(row){
        row.push({
          lowNum:'',
          highNum: '',
          price: ''
        })
      },
      handleDeletePrice(row,index){
        row.splice(index, 1)
      },
      handleColorClose(tag) {
        this.colorTags.splice(this.colorTags.indexOf(tag), 1);
        delete this.picList[tag]
        this.renderSkuList();
      },
      showColorInput() {
        this.inputColorVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagColorInput.$refs.input.focus();
        });
      },
      handleColorInputConfirm() {
        let inputValue = this.inputColorValue;
        if(inputValue.trim() === ''){
          this.inputColorVisible = false;
          this.inputColorValue = '';
          return
        }
        if(this.colorTags.indexOf(inputValue) > -1){
          this.msgWarning('颜色名称已存在，请重新填写')
          return
        }
        if (inputValue) {
          this.colorTags.push(inputValue.trim());
        }
        this.inputColorVisible = false;
        this.inputColorValue = '';
        this.picList[inputValue] = []
        this.renderSkuList();

      },
      handleShowVarHelp(event){
        this.$refs['varHelp'].$el.style.top = event.clientY + 'px'
        this.showVarHelp = true
      },
      handleSizeClose(tag) {
        this.sizeTags.splice(this.sizeTags.indexOf(tag), 1);
        this.renderSkuList();
      },
      showSizeInput() {
        this.inputSizeVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagSizeInput.$refs.input.focus();
        });
      },
      handleSizeInputConfirm() {
        let inputValue = this.inputSizeValue;
        if(inputValue.trim() === ''){
          this.inputSizeVisible = false;
          this.inputSizeValue = '';
          return
        }
         if(this.sizeTags.indexOf(inputValue) > -1){
          this.msgWarning('标签名称已存在，请重新填写')
          return
        }
        if (inputValue) {
          this.sizeTags.push(inputValue.trim());
        }
        this.inputSizeVisible = false;
        this.inputSizeValue = '';

        this.renderSkuList();
      },
      getConfigKey(){
      var _self = this
      getConfigKey("pic_url")
        .then(async (res) => {
           if (res.code == 200) {
            let array = []
            let result = await getDomainList({
              checkStatus: '02'
            })
            debugger
            if(result.rows.length > 0){
              for(let record of result.rows){
                array.push('http://' + record.busiDomain)
              }
            }
            array.push(res.msg)
            this.pictureAddresses  = array
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
      renderSkuList(){
        this.skuList = []
        if(this.sizeTags.length === 0 || this.colorTags.length === 0){
          return
        }

        for(let color of this.colorTags){
          for(let size of this.sizeTags){
            this.skuList.push({
              color: color,
              properName: '颜色:尺码',
              properVal: `${color}:${size}`,
              proSkuNo: '',
              quantity: '',
              price: ''
            })
          }
        }
      },
      getEditorRemarks(value){
        this.editorRemarks = value
      },
      handleChangeEditor(value){
        // this.form.remarks = value
      },
      handleSetMainImage(list ,index){
        list.map(item=>{
          item.isMain = "0"
        })
        list[index].isMain = "1"
        let record = list[index]
        //插入到第一个元素
        list.splice(index , 1)
        list.unshift(record)
      },
      hanldeDeleteImage(list, index){
        list.splice(index , 1)
        let haveMain = false
        for(let record of list){
          if(record.isMain === "1"){
            haveMain = true
          }
        }
        if(!haveMain){
          list[0].isMain = "1"
        }
      },
      async handleUploadImage(color){
        await this.getOssToken()
        this.currentColor = color;
        document.querySelector('#fileUpload').click()
      },
      getOssToken() {
        var _self = this
        getOSSToken()
        .then(function (res) {
          if (res.code == 200) {
            _self.aliyunOssToken = res.data
          } else {
            _self.$message.error(res.msg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      },
      handleSaveFile() {
        var _self = this
        var getSuffix = function (fileName) {
          var pos = fileName.lastIndexOf(".")
          var suffix = ""
          if (pos != -1) {
            suffix = fileName.substring(pos)
          }
          return suffix
        }

        var file = $("#fileUpload").val()
        if (file.length == 0) {
          alert("请选择文件")
        }

        var filename = new Date().getTime() + getSuffix(file)
        var formData = new FormData()

        //注意formData里append添加的键的大小写
        formData.append("key", _self.aliyunOssToken.dir + filename) //存储在oss的文件路径
        formData.append("OSSAccessKeyId", _self.aliyunOssToken.accessid) //accessKeyId
        formData.append("policy", _self.aliyunOssToken.policy) //policy
        formData.append("Signature", _self.aliyunOssToken.signature) //签名
        //如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了

        formData.append("file", $("#fileUpload")[0].files[0])
        formData.append("success_action_status", 200) //成功后返回的操作码

        var url = _self.aliyunOssToken.host
        var fileUrl =
          _self.aliyunOssToken.host + "/" + _self.aliyunOssToken.dir + filename
        $.ajax({
          url: url,
          type: "POST",
          data: formData,
          // async: false,
          cache: false,
          contentType: false,
          processData: false,
          success: function (data) {
            _self.picList[_self.currentColor].push({
              picUrl: fileUrl,
              isMain: _self.picList[_self.currentColor].length === 0 ? true : false
            })
            let array =JSON.parse(JSON.stringify(_self.picList))
            _self.picList = array
            $("#fileUpload").val(null)
          },
          error: function (data) {
             $("#fileUpload").val(null)
          },
        })
    },
    handleChangeProductType(){
      this.form.external_product_id = '0'
      if(this.form.external_product_id_type == "EAN" || this.form.external_product_id_type == "UPC"){
        this.productIds = [{
          name: '按设置生成',
          value: '1'
        },
        {
          name: '不汇出',
          value: '0'
        }]
      }else{
        this.productIds =  [
        {
        name: '不汇出',
        value: '0'
         }]
      }
    },
    getImageFileFromUrl(url, imageName,callback) {
      return new Promise(()=>{
          var blob = null;
          var xhr = new XMLHttpRequest();
          xhr.open("GET", url);
          xhr.setRequestHeader('Accept', 'image/jpeg');
          xhr.responseType = "blob";
          xhr.onload = () => {
          if (xhr.status == 200) {
            blob = xhr.response;
            let imgFile = new File([blob], imageName, {type: 'image/jpeg'});
          //console.log(imgFile)
            callback.call(this,imgFile);
          }};
          xhr.send();
      })
    }
    },
    mounted(){
      //this.getImageFileFromUrl('https://cbu01.alicdn.com/img/ibank/O1CN01t9Rf7J1JjM4nmT0KK_!!2211011801064-0-cib.jpg', '1111.png', function(){console.log(99)})
    }
  }
</script>

<style lang="scss" scoped>
.headerBorder {
  border: 1px solid darkgrey;
}
.container {
  margin-top: 15px;
}
.main {
  border: 1px solid darkgrey;
  border-top: none;
  width: 100%;
}
.el-header {
  height: 40px;
}
.inputSize {
  width: 300px;
}
.image {
  width: 88px;
  display: block;
  height: 100px;
}
.product-form {
  background: #ffffff;
  padding: 16px;
  ::v-deep .el-form-item__content {
    width: 600px;
  }

  ::v-deep .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  .wd100 {
    ::v-deep .el-form-item__content {
      width: calc(100% - 150px);
    }
  }
}
.pl_til {
  background-color: #ffffff;
  border-bottom: none;
  border-left: 4px solid #409eff;
  padding: 0 0 0 15px;
  font-size: 15px;
  color: #333333;
  font-weight: inherit;
}
.t_plane {
  border: none;
  border-radius: 0px;
}
.color-list {
  margin: 0 0 16px 0;
}
.price-set {
  font-size: 16px;
}
.sku-list {
  margin: 8px 0 0 0;
}
.pl-title {
  font-size: 14px;
  margin: 0 0 8px 0;
}
.extra-image-ul > li,
.extra-image-ul > li {
  background: #eeeeee;
}
.sort-img-item {
  position: relative;
  width: 100px;
  height: 100px;
  display: inline-block;
  img {
    width: 100px;
    height: 100px;
    position: absolute;
    left: 0;
  }
}

.extra-image-ul li {
  width: 100px;
  height: 100px;
  margin-right: 8px;
  margin-bottom: 8px;
  border: 1px solid rgb(221, 221, 221);
  position: relative;
  text-align: center;
  display: inline-block;
}
.add-image-button {
  background: #ebeef5;
}
.add-image-button > p {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  line-height: 1.4;
  width: 110%;
  font-size: 20px;
}
.item-badge {
  position: absolute;
  color: rgb(255, 165, 79);
  font-weight: bold;
  font-size: 14px;
  top: 5px;
  left: 6px;
  // -ms-transform: rotate(-35deg);
  // -webkit-transform: rotate(-35deg);
  // transform: rotate(-35deg);
  -webkit-transition: 0 0.1s ease-in;
  -moz-transition: 0 0.1s ease-in;
  -o-transition: 0 0.1s ease-in;
  transition: transform 0.1s ease-in;
  z-index: 100;
}
li .wish-product-img-ope,
li .wish-product-img-ope,
li .wish-product-img-ope {
  width: calc(100% - 8px);
  padding: 1px 4px;
  background: #3ba5ea;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 9;
  line-height: 20px;
  text-align: left;
  font-size: 12px;
  color: #ffffff;
  .set-main {
    float: left;
    cursor: pointer;
  }
  .set-delete {
    float: right;
    cursor: pointer;
  }
}
.price-set {
  ::v-deep .el-input--suffix .el-input__inner {
    padding-right: 16px;
  }
}
.insert-link {
  color: #409eff;
  display: inline-block;
  width: 66px;
  .variable-select-menu {
    position: absolute;
    top: 10px;
    left: 58px;
    z-index: 999999;
    background: #fff;
    border: 1px solid rgb(225, 227, 229);
    border-radius: 4px;
    font-size: 12px;
    display: none;
  }

  .variable-select-menu li {
    height: 28px;
    line-height: 28px;
    padding: 0 15px;
    cursor: pointer;
    position: relative;
    white-space: nowrap;
  }
  .variable-select-menu > ul > li:hover {
    background: #428bca;
    color: #fff;
  }
  .variable-select-menu > ul > li:hover .variable-pick-ul {
    display: block;
  }
}
.insert-link:hover .variable-select-menu {
  display: block;
}
.variable-select-box-text {
  color: #333333;
}
.sidebar__style {
  width: 160px;
  box-sizing: border-box;
  height: 100px;
  position: fixed;
  top: 150px;
  right: 0px;
  font-size: 14px;
}
.list__style {
  margin-bottom: 20px;
}
.list__style > div {
  border-left: 2px solid #409eff;
  padding-left: 10px;
  margin-top: 15px;
  cursor: pointer;
}
.button__style {
  border-radius: 5px;
  font-size: 14px;
  line-height: 16px;
  width: 45px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-bottom: 10px;
  border: 1px solid #999;
}
.submit__style {
  border: 1px solid #409eff;
  color: #fff;
  background-color: #409eff;
}
.text-link {
  color: #333;
}
.text-link:visited,
.text-link:hover {
  color: #333;
}
.form-remark {
  float: left;
  color: #606266;
}
.form-control {
  float: left;
  width: 500px;
}
.insert-link {
  color: #409eff;
  display: inline-block;
  width: 66px;
}
.title {
  border-left: 4px solid #409eff;
  padding-left: 15px;
  font-size: 16px;
  margin-bottom: 16px;
}
#main {
  background: #ffffff;
  padding: 16px;
  box-sizing: border-box;
  .title {
    border-left: 4px solid #409eff;
    padding-left: 15px;
    font-size: 16px;
    margin-bottom: 30px;
  }
  .check-list {
    margin: 0 0 16px 0;
  }
  ::v-deep .el-form-item__content {
    width: 600px;
  }
  .form-title {
    line-height: 40px;
    font-size: 16px;
  }
  .form-control {
    float: left;
    width: 500px;
  }
  .form-remark {
    float: left;
    color: #606266;
  }
  .image-hint {
    color: #606266;
  }
  .extra-image-ul > li,
  .extra-image-ul > li {
    background: #eeeeee;
    img {
      width: 100px;
      height: 100px;
      position: absolute;
      left: 0;
    }
  }

  .extra-image-ul > li {
    width: 100px;
    height: 100px;
    margin-right: 8px;
    margin-bottom: 8px;
    border: 1px solid rgb(221, 221, 221);
    position: relative;
    text-align: center;
    display: inline-block;
  }
  .extra-image-ul > li > p {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    line-height: 1.4;
    width: 110%;
  }
  .detail-image-ul.amazon > li .wish-product-img-ope,
  .detail-image-ul.lazada > li .wish-product-img-ope,
  .wish-product-img > li .wish-product-img-ope {
    width: calc(100% - 8px);
    padding: 1px 4px;
    background: #3ba5ea;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 9;
    line-height: 20px;
    text-align: left;
    font-size: 12px;
    .set-main {
      float: left;
      cursor: pointer;
    }
    .set-delete {
      float: right;
      cursor: pointer;
    }
  }
  .detail-image-ul.amazon > li .wish-product-img-ope > a,
  .detail-image-ul.lazada > li .wish-product-img-ope > a,
  .wish-product-img > li .wish-product-img-ope > a {
    color: #fff;
  }
  .item-badge {
    position: absolute;
    color: rgb(255, 165, 79);
    font-weight: bold;
    font-size: 14px;
    top: -8px;
    left: 0;
    // -ms-transform: rotate(-35deg);
    // -webkit-transform: rotate(-35deg);
    // transform: rotate(-35deg);
    -webkit-transition: 0 0.1s ease-in;
    -moz-transition: 0 0.1s ease-in;
    -o-transition: 0 0.1s ease-in;
    transition: transform 0.1s ease-in;
    z-index: 1;
  }
  .add-image-button {
    font-size: 24px;
    position: relative;
  }
  .add-image-button:hover .variable-select-box {
    display: block;
  }
  .variable-select-box {
    position: absolute;
    top: 0;
    left: 100px;
    z-index: 999999;
    background: #fff;
    border: 1px solid rgb(225, 227, 229);
    border-radius: 4px;
    font-size: 12px;
    display: none;
  }

  .variable-select-box li {
    height: 28px;
    line-height: 28px;
    padding: 0 15px;
    cursor: pointer;
    position: relative;
    white-space: nowrap;
  }
  .variable-select-box > ul > li:hover {
    background: #428bca;
    color: #fff;
  }
  .variable-select-box > ul > li:hover .variable-pick-ul {
    display: block;
  }

  .variable-pick-ul {
    position: absolute;
    top: -1px;
    left: 76px;
    background: #fff;
    border: 1px solid rgb(225, 227, 229);
    border-radius: 4px;
    z-index: 10;
    display: none;
  }
  .variable-pick-ul li:hover {
    background: #428bca;
    color: #fff;
  }
  .variable-pick-ul li {
    color: #000;
    white-space: nowrap;
  }
}
.insert-link {
  color: #409eff;
  display: inline-block;
  width: 66px;
  .variable-select-menu {
    position: absolute;
    top: 10px;
    left: 58px;
    z-index: 999999;
    background: #fff;
    border: 1px solid rgb(225, 227, 229);
    border-radius: 4px;
    font-size: 12px;
    display: none;
  }

  .variable-select-menu li {
    height: 28px;
    line-height: 28px;
    padding: 0 15px;
    cursor: pointer;
    position: relative;
    white-space: nowrap;
  }
  .variable-select-menu > ul > li:hover {
    background: #428bca;
    color: #fff;
  }
  .variable-select-menu > ul > li:hover .variable-pick-ul {
    display: block;
  }
}
.insert-link:hover .variable-select-menu {
  display: block;
}
.variable-select-box-text {
  color: #333333;
}
.sidebar__style {
  width: 160px;
  box-sizing: border-box;
  height: 100px;
  position: fixed;
  top: 150px;
  right: 0px;
  font-size: 14px;
}
.list__style {
  margin-bottom: 20px;
}
.list__style > div {
  border-left: 2px solid #409eff;
  padding-left: 10px;
  margin-top: 15px;
  cursor: pointer;
}
.button__style {
  border-radius: 5px;
  font-size: 14px;
  line-height: 16px;
  width: 45px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-bottom: 10px;
  border: 1px solid #999;
}
.submit__style {
  border: 1px solid #409eff;
  color: #fff;
  background-color: #409eff;
}
.text-link {
  color: #333;
}
.text-link:visited,
.text-link:hover {
  color: #333;
}
.form-label {
  display: inline-block;
  position: relative;
  line-height: 20px;
}
.field-name {
  position: absolute;
  right: 0;
  text-align: right;
  top: 20px;
  line-height: 20px;
}
</style>
